import { baseApi } from "./apiConfig";

export const getOfferDetails = async (offerRequest) => {
  try {
    const response = await baseApi.post("/portal/offerWizard", offerRequest);
    return response.data;
  } catch (error) {
    console.log(error, "Error in Offer Wizard");
    throw error;
  }
};

export const generateCifForOffer = async ({ listingId, userId }) => {
  try {
    const response = await baseApi.post(
      `portal/api/ci/generateCIFForOffer/${listingId}/${userId}`,
      { buyerEmailAddr: "" }
    );
    return response.data;
  } catch (error) {
    console.log("generate cif for offer api error", error);
    throw error;
  }
};

export const cifFileUpload = async ({ listingId }) => {
  try {
    const response = await baseApi.get(
      `portal/v2.0/cif/fileUploadConfig/${listingId}/CIF
`
    );
    return response.data;
  } catch (error) {
    console.log("cif file upload config api error", error);
    throw error;
  }
};

export const uploadFile = async (formData) => {
  try {
    const response = await baseApi.post("/portal/cif/uploadFile", formData);
    return response;
  } catch (error) {
    console.error("api uploadFile error:", error);
    throw error;
  }
};
export const deleteFile = async ({ listingId, fileId }) => {
  try {
    const response = await baseApi.post(
      `portal/cif/deleteFile/${listingId}/${fileId}`
    );
    return response;
  } catch (error) {
    console.error("api uploadFile error:", error);
    throw error;
  }
};

export const submitCifOffer = async ({ payload, cifId }) => {
  try {
    // portal/v2.0/ci/submit/document
    const response = await baseApi.post(
      `/portal/ci/submit/document/${cifId}`,
      payload
    );
    return response;
  } catch (error) {
    console.error("submit cif offer  error:", error);
    throw error;
  }
};

export const offerEmd = async ({ amount, listingId }) => {
  try {
    const response = await baseApi.get(`portal/emd/${listingId}/${amount}`);
    return response.data;
  } catch (error) {
    console.log("error in offer emd", error);
  }
};

export const financeEmd = async({listingId,amount,type}) =>{
  try {
    const response = await baseApi.get(`portal/emd-by-financetype-offer/${listingId}/${amount}/${type}`);
    return response.data;
  } catch (error) {
    console.log("error in finance emd",error);
  }
}
export const bidContigencyType = async ({listingId,amount,type}) => {
  try {
    const response = await baseApi.get(
      `/portal/api/bidContigency/${listingId}/${type}/${amount}`
    );
    return response.data;
  } catch (error) {
    console.log("Error while fetching getBidDepositContigency", error);
    throw error;
  }
};

export const submitOffer = async({payload}) =>{
  try {
    const response = await baseApi.post(`/portal/submitOffer/complete`,payload);
    return response.data;
  } catch (error) {
    console.log("Error in submit offer", error);
    throw error;
  }
}
export const getDocumentsCi = async({cifId}) =>{
    try{
      const response = await baseApi.post(`/portal/ci/getDocument/${cifId}`);
      return response.data;
    }catch(error){
      console.log("Error in get documents ci", error);
      throw error;
    }
}
export const  editCifApi = async({id})=>{
  try {
    const response = await baseApi.get(`/portal/ciOffer/document/${id}`);
    return response.data;
    
  } catch (error) {
    console.log("edit cif", error);
      throw error;
  }
}
export const  editCifApiNorm = async({id})=>{
  try {
    const timestamp = new Date().getTime();
    const response = await baseApi.get(`/portal/cif/documents/${id}?_=${timestamp}`);
    return response.data;
    
  } catch (error) {
    console.log("edit cif", error);
      throw error;
  }
}
export const verifyLicense = async(payload) => {
   try{
      const response = await baseApi.post(`/portal/ci/verifyLicenseDetails`,payload);
      return response.data;
    }catch(error){
      console.log("Error in verifiying documents", error);
      throw error;
    }
}